<script>
export default {
    name: "CheckPassword",
    methods:{
        check_error(error){
            if (
                error === "password_must_contain_8_or_more_characters" ||
                error === "password_must_contain_1_number_in_it" ||
                error === "password_must_contain_1_letter_in_it" ||
                error === "password_must_contain_1_capital_letter_in_it"
            ) return true
        }
    }
};
</script>
